import { Button, Img } from "components/new-landing-page";
import styled from 'styled-components';
import WobbleText from "components/WobbleText";

// Styled components
const Link = styled.a`
  position: relative;
  overflow: hidden;
  display: inline-block;
  text-decoration: none;
  font-size: 16px;
  border: none;
  cursor: pointer;

  span {
    display: inline-block;
    transition: transform 0.5s ease;
  }

  .originalLink {
    position: relative;
  }

  .duplicateLink {
    position: absolute;
    top: 100%;
    left: 0;
    width: 100%;
    text-align: center;
  }

  &:hover {
    .originalLink {
      transform: translateY(-100%);
    }
    .duplicateLink {
      transform: translateY(-100%);
    }
  }
`;

interface Props {
  className?: string;
}

export default function Header({ ...props }: Props) {
  return (
    <header
      {...props}
      className={`${props.className} flex md:flex-col self-stretch justify-between items-center gap-5 px-20 py-[22px] md:px-5 sm:p-5`}
    >
      <Img src="/images/new-landing-page/img_header_logo.png" alt="Headerlogo" className="h-[30px] w-[166px] object-contain" />
      <ul className="flex flex-wrap gap-7">
        <li>
          <Link href="#">
            <span className="originalLink font-manrope text-[18px] sm:text-[16px]">Press Release</span>
            <span className="duplicateLink font-manrope text-[18px] sm:text-[16px]">Press Release</span>
            {/* <Heading as="p" className="originalLink text-[18px] sm:text-[16px] font-medium">Press Release</Heading>
            <Heading as="p" className="duplicateLink text-[18px] sm:text-[16px] font-medium">Press Release</Heading> */}
          </Link>
        </li>
        <li>
          <Link href="#">
            <span className="originalLink font-manrope text-[18px] sm:text-[16px]">Blogs</span>
            <span className="duplicateLink font-manrope text-[18px] sm:text-[16px]">Blogs</span>
          </Link>
          {/* <a href="#">
            <Heading as="p" className="text-[18px] sm:text-[16px] font-medium">
              Blogs
            </Heading>
          </a> */}
        </li>
        <li>
          <Link href="#">
            <span className="originalLink font-manrope text-[18px] sm:text-[16px]">Testimonials</span>
            <span className="duplicateLink font-manrope text-[18px] sm:text-[16px]">Testimonials</span>
          </Link>
        </li>
        {/* <li>
        <WobbleText text="Wobble" />
        </li> */}
      </ul>
      <Button color="gradient" size="md" shape="round" className="min-w-[158px] rounded-[24px] px-[26px] md:hidden">
        Register Now
      </Button>
    </header>
  );
}
